import { nextPageAccessor } from '#pplx/frontend/apps/ask/hooks/collections-hooks/collection-mutations/nextPageAccessor.js';
import { listCollectionThreads } from '#pplx/frontend/apps/ask/queries/collection-queries/listCollectionThreads.js';
import { getCollectionThreadsQueryKey, getSidebarProjectThreadsQueryKey, } from '#pplx/frontend/apps/ask/queries/query-keys/collectionKeys.js';
import { LIBRARY_ITEM_LIMIT } from '#pplx/frontend/apps/ask/queries/thread-queries/constants.js';
export const PROJECT_SESSION_PRELOAD_FRESHNESS_MS = 10_000;
export function getSidebarProjectThreadsQueryOptions({ collectionSlug, limit, }) {
    return {
        queryKey: getSidebarProjectThreadsQueryKey({ collectionSlug, limit }),
        staleTime: 0,
        refetchOnMount: true,
        queryFn: () => listCollectionThreads({
            params: {
                collection_slug: collectionSlug,
                filter_by_user: false,
                filter_by_shared_threads: false,
                include_user_and_shared_threads: true,
                limit,
                offset: 0,
            },
            reason: 'sidebar-promoted-space-recent-threads',
            throwOnError: true,
        }),
    };
}
export function getProjectOverviewCollectionThreadsQueryParams({ filterByCurrentUser = false, threadType, searchTerm, } = {}) {
    return {
        filterByUser: filterByCurrentUser,
        includeUserAndSharedThreads: !filterByCurrentUser,
        includeAssets: true,
        includeArticles: true,
        threadType,
        searchTerm,
    };
}
export function getCollectionThreadsQueryOptions({ collectionSlug, filterByUser = false, filterBySharedThreads = false, includeUserAndSharedThreads = false, threadType, includeAssets = false, includeArticles = false, archivedOnly = false, limit = LIBRARY_ITEM_LIMIT, searchTerm, reason, throwOnError = false, }) {
    const querySlug = collectionSlug ?? '';
    return {
        queryKey: getCollectionThreadsQueryKey({
            collection_slug: querySlug,
            filter_by_user: filterByUser,
            filter_by_shared_threads: filterBySharedThreads,
            include_user_and_shared_threads: includeUserAndSharedThreads,
            thread_type: threadType,
            include_assets: includeAssets,
            include_articles: includeArticles,
            archived_only: archivedOnly,
            limit,
            search_term: searchTerm,
        }),
        queryFn: async ({ pageParam = 1 }) => {
            if (!querySlug)
                return [];
            const normalizedPage = !pageParam || pageParam < 1 ? 1 : pageParam;
            return listCollectionThreads({
                params: {
                    collection_slug: querySlug,
                    limit,
                    filter_by_user: filterByUser,
                    filter_by_shared_threads: filterBySharedThreads,
                    ...(includeUserAndSharedThreads ? { include_user_and_shared_threads: true } : {}),
                    ...(threadType ? { thread_type: threadType } : {}),
                    ...(includeAssets ? { include_assets: true } : {}),
                    ...(includeArticles ? { include_articles: true } : {}),
                    ...(archivedOnly ? { archived_only: true } : {}),
                    ...(searchTerm ? { search_term: searchTerm } : {}),
                    offset: (normalizedPage - 1) * limit,
                },
                reason,
                throwOnError,
            });
        },
        initialPageParam: 1,
        getNextPageParam: nextPageAccessor,
    };
}
//# sourceMappingURL=collectionThreadsQueryOptions.js.map